// extracted by mini-css-extract-plugin
module.exports = {"menu-wrapper":"_2b1fEVCmVh","user-box":"eu2q8IDOui","router-link":"OpZbS1aMUZ"};